"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeGmailLineBreakBeforeReply = void 0;

var _removeReply = require("sanitize-text/transformers/removeReply");

var _SanitizeConfiguration = require("../sanitizers/SanitizeConfiguration");

var isReply = function isReply(classList, id) {
  return id === _removeReply.OFFICE_365_REPLY_ID || classList && classList.contains && _removeReply.REPLY_CLASSLIST.some(function (className) {
    return classList.contains(className);
  });
};

var removeGmailLineBreakBeforeReply = function removeGmailLineBreakBeforeReply(_ref) {
  var node = _ref.node;

  if (!node || !node.tagName || node.tagName.toLowerCase() !== 'br') {
    return null;
  }

  if (!node.nextElementSibling || !node.nextElementSibling.tagName) {
    return null;
  } // check to see if the next sibling is a reply


  var _node$nextElementSibl = node.nextElementSibling,
      classList = _node$nextElementSibl.classList,
      id = _node$nextElementSibl.id;

  if (!isReply(classList, id)) {
    return null;
  } // replace <br /> with <span> so it doesn't take up any veritcal space


  var span = _SanitizeConfiguration.secureDocument.createElement('span');

  span.innerHTML = '';
  return {
    node: span
  };
};

exports.removeGmailLineBreakBeforeReply = removeGmailLineBreakBeforeReply;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/sanitize-text/static-1.1206/js/transformers/removeGmailLineBreakBeforeReply.js
// module id = 816
// module chunks = 209 210 211 212